export default [
	{ label: 'Beliebig', value: '0' },
	{ label: 'mind. 70%', value: '70' },
	{ label: 'mind. 80%', value: '80' },
	{ label: 'mind. 90%', value: '90' },
	{ label: 'mind. 95%', value: '95' },
];
